import { render, staticRenderFns } from "./manual-licenses-dialog.vue?vue&type=template&id=becfaf74&"
import script from "./manual-licenses-dialog.vue?vue&type=script&lang=ts&"
export * from "./manual-licenses-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./manual-licenses-dialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports